module.exports = __webpack_public_path__ + "img/MenuBlueIcon.f54b4a18.svg";